module.exports = __webpack_public_path__ + "static/media/Apple iPhone 5c Green.ec139d87.png";